import React from 'react'

import {
  AlertCard,
  AlertCardContent,
  AlertCardVariant,
  AlignItems,
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  JustifyContent,
  Spinner,
} from '@gousto-internal/citrus-react'
import PropTypes from 'prop-types'

class OrderCancelButton extends React.PureComponent {
  handleCancelBox = () => {
    const { orderState, orderId, deliveryDayId, orderCancelStart, deliveryDay } = this.props
    if (orderState !== 'scheduled') {
      orderCancelStart(orderId, deliveryDayId, deliveryDay, 'pending')
    } else {
      orderCancelStart(null, deliveryDayId, deliveryDay, 'projected')
    }
  }

  render() {
    const {
      contentPending,
      didCancelProjectedError,
      deliveryDayId,
      orderCancelPending,
      orderId,
      osrDeliveryDayId,
      osrOrderId,
      projectedOrderCancelPending,
    } = this.props

    const isActiveDeliveryDay = Boolean(
      deliveryDayId && osrDeliveryDayId && deliveryDayId === osrDeliveryDayId,
    )
    const isActiveOrder = Boolean(orderId && osrOrderId && orderId === osrOrderId)
    const isSkipInProgress = contentPending || orderCancelPending || projectedOrderCancelPending
    const isActiveSkipPending =
      (contentPending && (isActiveDeliveryDay || isActiveOrder)) ||
      (orderCancelPending && isActiveOrder) ||
      (projectedOrderCancelPending && isActiveDeliveryDay)

    return (
      <div>
        {didCancelProjectedError ? (
          <AlertCard variant={AlertCardVariant.Warning} data-testid="cancelError">
            <AlertCardContent>
              Whoops, there was a problem cancelling this order, please try again.
            </AlertCardContent>
          </AlertCard>
        ) : null}
        <Button
          data-testid="cancelButton"
          colorVariant={ButtonColorVariant.Secondary}
          onClick={this.handleCancelBox}
          width={['100%', 'auto']}
          disabled={isSkipInProgress}
        >
          {isActiveSkipPending ? (
            <Box
              alignItems={AlignItems.Center}
              display={Display.Flex}
              justifyContent={JustifyContent.Center}
              gap={2}
            >
              <Spinner color={Color.Secondary_400} data-testid="cancelButtonSpinner" size={6} />
              <span>Skipping delivery...</span>
            </Box>
          ) : (
            'Skip delivery'
          )}
        </Button>
      </div>
    )
  }
}

OrderCancelButton.propTypes = {
  orderId: PropTypes.string,
  deliveryDayId: PropTypes.string,
  osrOrderId: PropTypes.string,
  osrDeliveryDayId: PropTypes.string,
  orderState: PropTypes.string,
  didCancelProjectedError: PropTypes.bool,
  orderCancelStart: PropTypes.func,
  deliveryDay: PropTypes.string,
  contentPending: PropTypes.bool,
  orderCancelPending: PropTypes.bool,
  projectedOrderCancelPending: PropTypes.bool,
}

OrderCancelButton.defaultProps = {
  orderId: '',
  deliveryDayId: '',
  osrOrderId: '',
  osrDeliveryDayId: '',
  orderState: '',
  didCancelProjectedError: false,
  orderCancelStart: () => {},
  deliveryDay: '',
  contentPending: false,
  orderCancelPending: false,
  projectedOrderCancelPending: false,
}

export default OrderCancelButton
